import axiosInstance from '../services/AxiosInstance';

export function getAvailabilityStatus(pageNum = 1, pageSize = 10, searchTerm = "", filterQuery = "") {
    return axiosInstance.get(`availability-status?pageNum=${pageNum}&pageSize=${pageSize}&search=${searchTerm}`);
}

export function deleteAvailabilityStatus(id) {
    return axiosInstance.delete(`availability-status/${id}`);
}

export function createAvailabilityStatus(id) {
    return axiosInstance.post(`availability-status`,id);
}

export function updateAvailabilityStatus(id, data) {
    return axiosInstance.put(`availability-status/${id}`,data);
}
